/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter"


export var searchObjectCollisionSystem = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectAcceleratorParameters = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectPhysicsTheme = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectWorkingGroup = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectFinalStates = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectFinalStatesSignature = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectInterpretation = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectSmAnalysisCharacteristics = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectFurtherSearchCategorisation = {
    any : true,
    categories : [],
    keywords : []
}

export var searchObjectFurtherCategorisationHeavyIon = {
    any : true,
    categories : [],
    keywords : []
}


export var globalSearchObject = {
    globalPaper: true,
    globalPas: false,
    globalAny : false,
    allSearchObjects: [
    
        searchObjectCollisionSystem,
    
        searchObjectAcceleratorParameters,
    
        searchObjectPhysicsTheme,
    
        searchObjectWorkingGroup,
    
        searchObjectFinalStates,
    
        searchObjectFinalStatesSignature,
    
        searchObjectInterpretation,
    
        searchObjectSmAnalysisCharacteristics,
    
        searchObjectFurtherSearchCategorisation,
    
        searchObjectFurtherCategorisationHeavyIon,
    
    ]

}
                                   